let { $ } = window;

if (parseInt($().jquery, 10) < 3) {
  $ = require('jquery');
}

$(() => {
  $('.login-form').on('submit', function callback(e) {
    e.preventDefault();
    const $this = $(this);
    const $button = $this.find('.button.primary');
    const $error = $this.find('.error-container');

    $button.prop('disabled', true);

    $.ajax('/forum-login',
      {
        type: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: $this.serialize(),
        url: '/forum-login', // weird hack to get forum login to work
        success() {
          const currentLocation = document.URL;
          const prevLocation = document.referrer;

          if (currentLocation.indexOf('/login') !== -1) {
            if (prevLocation && prevLocation.indexOf('/login') === -1 && prevLocation.indexOf('boxingscene.com') !== -1) {
              window.location.href = prevLocation;
            } else {
              window.location = '/forums';
            }
          } else if (currentLocation.indexOf('/forums') !== -1) {
            window.location.reload();
          } else {
            window.location = '/forums';
          }
        },
        error(error) { $error.html(error.responseJSON).show(); },
        complete: () => $button.removeAttr('disabled'),
      });
  });
});
